import(/* webpackMode: "eager", webpackExports: ["default"] */ "/hisea-ssr/src/components/ForgotPasswordPage/forgotPasswordPage.js");
